import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import ListFarms from "./ListFarms.js"
import ViewFarm from "./ViewFarm.js"
import CreateFarm from "./CreateFarm.js"
import EditFarm from "./EditFarm.js"




export default function Farms() {

    return (
        <Routes>
            <Route path="/" element={<ListFarms />} />
            <Route path="/view/:id" element={<ViewFarm />} />
            <Route path="/edit/:id" element={<EditFarm />} />
            <Route path="/create/" element={<CreateFarm />} />
        </Routes>
    )
}


